import { render, staticRenderFns } from "./add-to-account.vue?vue&type=template&id=83bc5d56&scoped=true&"
import script from "./add-to-account.vue?vue&type=script&lang=js&"
export * from "./add-to-account.vue?vue&type=script&lang=js&"
import style0 from "./add-to-account.vue?vue&type=style&index=0&id=83bc5d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bc5d56",
  null
  
)

export default component.exports